"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTransitionGroup = require("react-transition-group");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormsWrapper = function FormsWrapper(props) {
  var isAppealFormOpened = props.isAppealFormOpened,
      checkedItems = props.checkedItems,
      toggleAppealForm = props.toggleAppealForm,
      form = props.form;
  var buttonCls = (0, _classnames["default"])({
    toggleSlideForm: true,
    'open-form': isAppealFormOpened,
    'hidden-toggle-button': !checkedItems.length
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: buttonCls,
    onClick: toggleAppealForm
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon-arrow-alt-left"
  })), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": isAppealFormOpened && !!checkedItems.length,
    classNames: "pageSliderRightForm",
    appear: true,
    enter: true,
    exit: true,
    timeout: 1000 // timeout={{ enter: 100, exit: 600 }}
    ,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "appealFormWrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: buttonCls,
    onClick: toggleAppealForm
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon-arrow-alt-right"
  })), form)));
};

FormsWrapper.propTypes = {
  form: _propTypes["default"].node,
  isAppealFormOpened: _propTypes["default"].bool,
  checkedItems: _propTypes["default"].array,
  toggleAppealForm: _propTypes["default"].func
};
var _default = FormsWrapper;
exports["default"] = _default;